import React from 'react';
import { useWindowSize } from '../../../tools/hooks';
import { useTranslation } from '../../../tools/i18n';
import { StickyItem } from '../../StickyItem';

export interface DescriptionWithLang {
  lang: string;
  value: string;
}

export interface DescriptionShopV2Props {
  title: string;
  descriptions: DescriptionWithLang[];
}

const DescriptionShopV2: React.FC<DescriptionShopV2Props> = ({ title, descriptions }) => {
  const { language } = useTranslation();
  const { isMobile } = useWindowSize();

  const currentDescription =
    descriptions?.find((d) => d?.lang === language)?.value ||
    descriptions?.find((d) => d?.lang === 'fr')?.value;

  return (
    <div className="DescriptionShopV2">
      {isMobile ? null : (
        <StickyItem>
          <h1 className="DescriptionShopV2__title">{title}</h1>
        </StickyItem>
      )}
      {currentDescription ? (
        <p
          className="DescriptionShopV2__description"
          dangerouslySetInnerHTML={{ __html: currentDescription }}
        />
      ) : null}
    </div>
  );
};

export default DescriptionShopV2;
